import { imageRegistry } from "../../data/imageRegistry";
import { vehicleExamples, vehicleTypeSummary } from "../../content/site";
import { ResponsiveImage } from "../ResponsiveImage/ResponsiveImage";

export function VehicleEligibility() {
  return (
    <section
      id="vehicle-fit"
      className="vehicle-fit section section--standard"
      data-review-region="vehicle-fit-proof"
      aria-labelledby="vehicle-fit-title"
    >
      <div className="section-shell">
        <div className="vehicle-fit__layout">
          <div className="section-intro vehicle-fit__intro">
            <p className="section-kicker">本当にこんな状態でも？</p>
            <h2 id="vehicle-fit-title">
              <span>車の状態だけで、</span>
              <span>あきらめなくて大丈夫です。</span>
            </h2>
            <p>
              写真のようにタイヤがない車や、エンジンがかからない車も、車両の状態を確認して査定・引き取りしています。
            </p>
          </div>

          <div className="vehicle-fit__evidence">
            <figure className="proof-figure proof-figure--tireless">
              <ResponsiveImage
                image={imageRegistry.tirelessVehicleProof}
                className="responsive-image--proof"
                mobilePortrait
                signature="matsushima-real-work-proof"
              />
              <figcaption className="image-caption">
                実際に査定・引き取りした、タイヤのない車両
              </figcaption>
            </figure>
          </div>

          <div className="vehicle-fit__details">
            <ul className="plain-check-list">
              {vehicleExamples.map((example) => (
                <li key={example}>{example}</li>
              ))}
            </ul>
            <p className="vehicle-types-summary">{vehicleTypeSummary}</p>
            <p className="fine-print">
              車両・書類の状況を確認してご案内します。無条件の買取を保証するものではありません。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
